import React from 'react'

import { Button, Paragraph } from '../../../components'

export function ModuleLoadFailed() {
  return (
    <div className="flex h-full w-full flex-col items-center p-2">
      <div>
        <Paragraph className="p-1.5 text-gray-600 dark:text-gray-200">
          The Sidebar Widget didn't load successfully. Please refresh the page.
        </Paragraph>
        <Button className="m-1.5 mt-2.5" onClick={() => window.location.reload()}>
          Refresh Page
        </Button>
      </div>
    </div>
  )
}
